<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />

<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-trash"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<div class="container">
  <div class="confirm-align">
    <h4><strong><span [innerHTML]="content"></span></strong></h4>
  </div>
</div>

<kendo-dialog-actions>
  <button kendoButton themeColor="info" (click)="confirmClose()">
    {{okText}} </button>
  <button kendoButton themeColor="light" (click)="cancelClose()">
    {{cancelText}} </button>
</kendo-dialog-actions>
